// extracted by mini-css-extract-plugin
module.exports = {"overlay":"PnMCallbackConfirmationModal_overlay__V8BTP","modal-container":"PnMCallbackConfirmationModal_modal-container__puEXg"};